/**
 * 公告工具函数
 */

/**
 * 检查公告是否需要显示
 * @returns {Promise<boolean>} 是否需要显示公告
 */
export async function shouldShowAnnouncement() {
  try {
    console.log('Checking announcement status...')

    // 获取公告配置
    const response = await fetch('/announcement.json')
    if (!response.ok) {
      console.log('Failed to fetch announcement.json:', response.status)
      return false
    }

    const announcement = await response.json()
    console.log('Announcement data:', announcement)

    // 检查公告是否启用
    if (!announcement.enable) {
      console.log('Announcement is disabled')
      return false
    }

    // 检查是否已经标记为已读
    const dismissedTime = localStorage.getItem('announcement_dismissed')
    console.log('Dismissed time:', dismissedTime)

    if (dismissedTime) {
      // 如果公告有更新时间，可以根据更新时间来判断是否需要重新显示
      // 这里简化处理，如果已读时间在24小时内则不再显示
      const now = Date.now()
      const dismissed = parseInt(dismissedTime)
      const oneDayMs = 24 * 60 * 60 * 1000

      if (now - dismissed < oneDayMs) {
        console.log('Announcement dismissed within 24 hours')
        return false
      }
    }

    console.log('Announcement should be shown')
    return true
  } catch (error) {
    console.error('Error checking announcement:', error)
    return false
  }
}

/**
 * 获取公告数据
 * @returns {Promise<Object|null>} 公告数据
 */
export async function getAnnouncement() {
  try {
    const response = await fetch('/announcement.json')
    if (!response.ok) {
      return null
    }
    return await response.json()
  } catch (error) {
    console.error('Error loading announcement:', error)
    return null
  }
}

/**
 * 清除公告已读标记（用于测试）
 */
export function clearAnnouncementDismissed() {
  localStorage.removeItem('announcement_dismissed')
  console.log('Announcement dismissed flag cleared')
}
